/**
 * Test comment
 */
const test = () => {
  console.log('common');
};

export default test;